import {Locale} from '@aboutyou/config';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../../constants/colors';
import {
  desktopAndUpLinaria,
  tabletAndDownLinaria,
} from '../../../../constants/customMedia';
import {FONT_WEIGHTS} from '../../../../constants/typography';
import {Icon} from '../../../atoms/Icon/Icon';
import {getWoohooCampaignLogo} from '../utils/getWoohooCampaignLogo';
import {getWoohooCampaignLogoSuffix} from '../utils/getWoohooCampaignLogoSuffix';

const fontFamily = 'Helvetica Neue Condensed Bold';

export const WoohooCampaignLogo: FC<{locale: Locale}> = ({locale}) => {
  return (
    <Wrapper data-testid="WoohooCampaignLogo">
      <WoohooIcon asset={getWoohooCampaignLogo(locale)} />
      <WoohooText>{getWoohooCampaignLogoSuffix(locale)}</WoohooText>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  height: 100%;
  transition: opacity 200ms linear;
`;

const WoohooIcon = styled(Icon)`
  width: 100%;
  height: 100%;
  max-width: 70px;

  ${desktopAndUpLinaria(`display: none;`)}
`;

const WoohooText = styled.span`
  display: flex;
  font-family: '${fontFamily}', 'sans-serif';
  font-size: 30px;
  font-weight: ${FONT_WEIGHTS.bold};
  background-color: ${COLORS.Black};
  color: ${COLORS.White};
  text-transform: uppercase;
  padding: 0 4px;

  ${tabletAndDownLinaria('display: none;')}
`;
